export default ` 
@media print {
  .pagebreak {
      clear: both;
      page-break-before : always;
  }
}

.pagebreak {

page-break-before: always;
}

.html {
  height: auto !important;
}

* {
  background: transparent !important;
  color: #000 !important;
  box-shadow: none !important;
  text-shadow: none !important;
}

.h1,
h1 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 10.5pt;
}
.h10pt {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 10pt;
}
.h11pt {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 11pt;
}
.h12pt {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 12pt;
}
.h2 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 9.5pt;
}
.s1 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 8pt;
}
.s2 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 7.5pt;
}
.p,
p {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 9pt;
}
.s3 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 11pt;
}
.h3 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 9.5pt;
}
.s4 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 7pt;
}
.hs {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 8.5pt;
}
.h5 {
font-family: "Eras Demi ITC", sans-serif;
font-weight: normal;
font-size: 6pt;
}

.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12 {
  float: left;
}

.col-md-12 {
  width: 100%;
}
.col-md-11 {
  width: 91.66666667%;
}
.col-md-10 {
  width: 83.33333333%;
}
.col-md-9 {
  width: 75%;
}
.col-md-8 {
  width: 66.66666667%;
}
.col-md-7 {
  width: 58.33333333%;
}
.col-md-6 {
  width: 50%;
}
.col-md-5 {
  width: 41.66666667%;
}
.col-md-4 {
  width: 33.33333333%;
}
.col-md-3 {
  width: 25%;
}
.col-md-2 {
  width: 16.66666667%;
}
.col-md-1 {
  width: 8.33333333%;
}

.btn-toolbar,
.Allheaders,
.panel-heading {
display: none;
}

.card-body {
padding: 0rem 0rem !important
}
.dd {
margin-inline-start: 0;
margin-bottom: 0rem;
}

.row {
padding-right: 0;
padding-left: 0;
margin-top: 0; 
}

#generatorId {
position: absolute; 
top: 0.1in;
left: 1.45in;
}

#pageNumber {
position: absolute;
top: 0.1in;
left: 3.78in;
}

#emergencyPhone {
position: absolute;
top: 0.1in;
left: 4.28in;
}

#generatorNameCompany {
position: absolute;
top: 0.61in;
left: 0.15in;
}

#generatorAddress {
position: absolute;
top: 0.83in; 
left: 0.15in;
}

#Phone {
position: absolute;
top: 0.98in;
left: 0.82in;
}

#generatorName {
position: absolute; 
top: 0.98in; 
left: 2.6in;
}
#TransporterCompany1 {
position: absolute;
top: 1.33in; 
left: 0.15in;
}

#USEpaIDNumberTransporter1 {
position: absolute;
top: 1.35in;
left: 5.64in;
}

#TransporterCompany2 {
position: absolute; 
top: 1.68in;
left: 0.1in 
}
#USEpaIDNumberTransporter2 {
position: absolute; 
top: 1.66in; 
left: 5.64in;
}

#FacilityName {
position: absolute; 
top: 1.95in; 
left: 0.15in
}


#FacilitiyAddress {
  position: absolute; 
  top: 2.1in;
  left: 0.15in;
  }
  
  #USEpaIDNumber2 {
  position: absolute; top: 2.15in; left: 5.64in;
  }

#FacilityPhone {
position: absolute; top: 2.33in; left: 0.82in;
}


.card {
border: none;
padding: 0 !important;
margin: 0 !important;
}

.card-body {
padding: 0 !important;
margin: 0 !important;
}

.contHm {
position: relative;
}

#handlingInstructions {
height: 0.675in; position: absolute; top: 4.995in; left: 0.125in; white-space: pre-wrap;
}

#generatorId2 {
position: absolute; top: 0.08in; left: 2.25in;
}

#pageNumber2 {
position: absolute; top: 0.08in; left: 4.5in;

}
#shippingnumber2 {
position: absolute; top: 0.08in; left: 5.25in;
}

#Transporter1p2 {
position: absolute; top: 0.975in; left: 1.75in;
}

#Epaid1p2 {
position: absolute; top: 0.975in; left: 5.4in
}

#Transporter2p2 {
position: absolute; top: 1.325in; left: 1.75in;
}

#Epaid2p2 {
position: absolute; top: 1.345in; left: 5.4in
}

#handlingInstructionsp2 {
  width: 7.5in; height: 0.675in; position: absolute; top: 7.105in; left: 0.125in; white-space: pre-wrap;
}

.card {
  border: none;
}`;
